import {
    KIP_500_BV_12,
    KIP_500_BV_12_UM,
} from '../constants';
import { AppId } from '../enums/elementId';
import { setElementVisibility } from './visibility';

/**
 * fn to update Seal image
 *
 * @param selectedTariffId - selected Tariff Id
 * @param isContentEnabled - is Content Enabled
 */
export const updateSeal = (selectedTariffId: string, isContentEnabled: boolean) => {
    if (isContentEnabled && (selectedTariffId === KIP_500_BV_12_UM || selectedTariffId === KIP_500_BV_12)) {
        setElementVisibility(AppId.SEAL_IMG, true);
    }
    else {
        setElementVisibility(AppId.SEAL_IMG, false);
    }
};
